
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 300 126","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M123.346 64.875C122.31 97.72 94.845 123.506 62 122.47 29.156 121.434 3.37 93.969 4.405 61.124 5.441 28.279 32.907 2.494 65.751 3.529c32.845 1.036 58.631 28.502 57.595 61.346z","stroke":"#F0F0F2","stroke-width":"7"}}),_c('path',{attrs:{"d":"M65.751 3.53a59.502 59.502 0 0156.52 48.057 59.498 59.498 0 01-73.439 68.979A59.493 59.493 0 014.405 61.15 59.5 59.5 0 0118.53 24.477","stroke":"#56BFC7","stroke-width":"7","stroke-linecap":"round"}}),_c('rect',{attrs:{"x":"30.876","y":"47","width":"67","height":"17","rx":"8.5","fill":"#8CDAE3"}}),_c('rect',{attrs:{"x":"23.876","y":"70","width":"81","height":"9","rx":"4.5","fill":"#E6E7E9"}})]),_c('rect',{attrs:{"x":"142.876","y":"11","width":"4","height":"40","rx":"2","fill":"#F0F0F2"}}),_c('rect',{attrs:{"x":"156.876","y":"11","width":"116","height":"8","rx":"4","fill":"#E6E7E9"}}),_c('rect',{attrs:{"x":"156.876","y":"29","width":"90","height":"20","rx":"10","fill":"#F0F0F2"}}),_c('rect',{attrs:{"x":"142.876","y":"75","width":"4","height":"40","rx":"2","fill":"#F0F0F2"}}),_c('rect',{attrs:{"x":"156.876","y":"75","width":"54","height":"8","rx":"4","fill":"#E6E7E9"}}),_c('rect',{attrs:{"x":"156.876","y":"93","width":"44","height":"20","rx":"10","fill":"#F0F0F2"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.876)","d":"M0 0h126v126H0z"}})])])])
          )
        }
      }
    